import { toastr } from "react-redux-toastr";

export const MessageTypes = {
  Error: "error",
  Info: "info",
  Success: "success",
  Warning: "warning"
};

export const showAlert = msg => {
  let options = {timeOut:5000}
  options={...options, ...(msg.options || {})}
  switch (msg.msg_type) {
    case MessageTypes.Error: {
      toastr.error("", msg.msg_text, options);
      break;
    }
    case MessageTypes.Success: {
      toastr.success("", msg.msg_text, options);
      break;
    }
    case MessageTypes.Warning: {
      toastr.warning("", msg.msg_text, options);
      break;
    }
    case MessageTypes.Info: {
      toastr.info("", msg.msg_text, options);
      break;
    }
    default: {
    }
  }
};

export const displayMessage = (
  msg_text = "",
  msg_type = MessageTypes.Error
) => {

  showAlert({ msg_type: msg_type, msg_text: msg_text });
};



// WEBPACK FOOTER //
// ./src/utility/alertHelper.js